import type { Sessione } from "../api/tipi"

/** La sessione vive in localStorage e non scade: il telefono resta collegato
 *  per tutto il Festival. Finisce solo se il server la rifiuta — reset della
 *  password o uscita dal gruppo — o con "Esci" (MODELLO_DATI.md § users). */
const CHIAVE = "giuria-trash:sessione"

export function leggiSessione(): Sessione | null {
  const grezzo = localStorage.getItem(CHIAVE)
  if (!grezzo) return null
  try {
    const s = JSON.parse(grezzo) as Sessione
    // Una sessione di prima degli account non ha `user`: si riaccede.
    return s?.token && s?.edition_id && s?.user?.id ? s : null
  } catch {
    return null
  }
}

export function salvaSessione(s: Sessione): void {
  localStorage.setItem(CHIAVE, JSON.stringify(s))
}

/** Senza `token` dimentica comunque; con `token` solo se è ancora quella
 *  salvata. Una scheda con una sessione ormai vecchia (401/4401) altrimenti
 *  cancellerebbe quella nuova che un'altra scheda ha appena salvato — per
 *  esempio dopo un reset della password fatto altrove. */
export function dimenticaSessione(token?: string): void {
  if (token != null && leggiSessione()?.token !== token) return
  localStorage.removeItem(CHIAVE)
}
